import React, { useState } from "react";
import { Link } from "react-router-dom";

import { setCookie } from "../utility/Cookie";

const LoginForm = () => {
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });

  const [isPosting, setIsPosting] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    setIsPosting(true);
    setError("");
    e.preventDefault();
    fetch(`${process.env.REACT_APP_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(userData),
    })
      .then((res) => res.json())
      .then((data) => {
        setError(data.status);
        setIsPosting(false);
        if (data.status === "success") {
          console.log(data.msg);
          setCookie("_r_", data.msg.user.role, 1);
          setCookie(
            "_g_",
            JSON.stringify({
              first_name: data.msg.user.first_name,
              last_name: data.msg.user.last_name,
              email: data.msg.user.email,
            }),
            1
          );
          setCookie("_t_", data.msg.token, 1);
          // localStorage.setItem("token", data.msg.token);
          // localStorage.setItem(
          //   "_g_user",
          //   JSON.stringify({
          //     first_name: data.msg.user.first_name,
          //     last_name: data.msg.user.last_name,
          //     email: data.msg.user.email,
          //   })
          // );
          window.location.href = "/";
          setIsPosting(false);
          setError("");
        }
      })
      .catch((err) => {
        console.log(err);
        setIsPosting(false);
        setError("");
      });
  };

  return (
    <div className="contactForm">
      <div className="row">
        <div className="col-12">
          <Link to="/">
            <img src="BlueLogo.svg" alt="logo" />
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <h1>Welcome Back</h1>

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="emailForm" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                className="form-control"
                id="emailForm"
                onChange={(e) =>
                  setUserData({ ...userData, email: e.target.value })
                }
              />
            </div>

            <div className="mb-1">
              <label htmlFor="passwordForm" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="passwordForm"
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    password: e.target.value,
                  })
                }
              />
            </div>
            <div className="error my-2">
              <span>{error}</span>
            </div>
            <button
              className="btn contBut mt-2"
              type="submit"
              disabled={isPosting}
            >
              {isPosting ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
